import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconViewScheduleComponent } from "./med-icon-view-schedule.component";

@NgModule({
  declarations: [
    MedIconViewScheduleComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconViewScheduleComponent,
  ],
})
export class MedIconViewScheduleModule { }
